import { nowTimestamp } from './dateUtils';

import { STORAGE_KEY_DYNAMIC_USER_LAST_EBON_INFO_ID } from '../constants/storage';

export function getStorageKey(prefix) {
    return prefix + window.location.origin.replace('https://', '');
}

export function clearExpiredLocalStorageKey(storageKey) {
    // get previously stored
    const dynamicRedirectionStored = JSON.parse(localStorage.getItem(storageKey));

    // clear expired
    if (dynamicRedirectionStored && nowTimestamp() > dynamicRedirectionStored.expiration) {
        localStorage.removeItem(storageKey);
    }
}
export function clearLocalStorageKey(storageKey) {
    localStorage.removeItem(storageKey);
}

export function clearExpiredSessionStorageKey(storageKey) {
    // get previously stored
    const dynamicRedirectionStored = JSON.parse(sessionStorage.getItem(storageKey));

    // clear expired
    if (dynamicRedirectionStored && nowTimestamp() > dynamicRedirectionStored.expiration) {
        sessionStorage.removeItem(storageKey);
    }
}

export const catchUserLastEbonInfo = (
    email,
    phoneNumber,
    firstname,
    lastname,
    street,
    postcode,
    city,
    country
) => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_USER_LAST_EBON_INFO_ID);

    clearExpiredSessionStorageKey(storageKey);

    const dynamicUserLastEbonInfoUpdated = {};
    dynamicUserLastEbonInfoUpdated.email = email;
    dynamicUserLastEbonInfoUpdated.phoneNumber = phoneNumber;
    dynamicUserLastEbonInfoUpdated.firstname = firstname;
    dynamicUserLastEbonInfoUpdated.lastname = lastname;
    dynamicUserLastEbonInfoUpdated.street = street;
    dynamicUserLastEbonInfoUpdated.postcode = postcode;
    dynamicUserLastEbonInfoUpdated.city = city;
    dynamicUserLastEbonInfoUpdated.country = country;

    sessionStorage.setItem(storageKey, JSON.stringify(dynamicUserLastEbonInfoUpdated));
};



// WEBPACK FOOTER //
// ./src/utils/storageUtils.js